<template>
  <div>

    <div>
      <v-form ref="form">
        <v-container>
          <v-layout wrap>

            <v-flex md2 sm12>
              <v-select item-text="text" :items="filterBy" v-model="selected_filter_by"
                :label="$t('drivers.captainShiftStats.filterBy')"></v-select>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.from')" v-model="from"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.to')" v-model="to"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
              <date-picker-multiple v-model="selected_month" />
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Year' || selected_filter_by == 'Summer Season'">
              <v-select :items="years" item-text="Year" v-model="selected_year" :label="$t('drivers.captainShiftStats.selectYear')"></v-select>
            </v-flex>
            <!--<v-flex md2 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">Export
                PDF</v-btn>
            </v-flex>-->
            <v-flex md2 sm12>
              <v-select item-text="text" :items="[{ text: $t('common.all'), value: 'All' }, { text: $t('drivers.captainShiftStats.normal'), value: 'Normal' }, { text: $t('drivers.captainShiftStats.seasonal'), value: 'Seasonal' }, { text: $t('drivers.captainShiftStats.specific'), value: 'Specific' }]" v-model="driver_type"
                :label="$t('drivers.captainShiftStats.driverType')"></v-select>
            </v-flex>
            <v-flex md2 sm12 v-if="driver_type == 'Specific'">
              <v-autocomplete v-model="selectedCaptain" clearable dense :items="captains" :loading="captainLoading"
                :search-input.sync="searchCaptainParam" :label="$t('drivers.captainShiftStats.captain')" item-text="text" item-value="id"
                :placeholder="$t('drivers.captainShiftStats.searchForCaptain')" no-filter :debounce-search="250"><template slot="item"
                  slot-scope="captains">
                  <v-list-tile-content>
                    <v-list-tile-title :style="captains.item.deleted_at ? { color: 'red' } : {}" v-html="captains.item.first_name +
                      ' ' +
                      captains.item.last_name
                      "></v-list-tile-title>
                    <v-list-tile-sub-title :style="captains.item.deleted_at ? { color: 'red' } : {}"
                      v-html="captains.item.username"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex md1 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(false)" :loading="loading">{{ $t("drivers.captainShiftStats.getData") }}</v-btn>
            </v-flex>
            <v-flex md1 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">{{ $t("drivers.captainShiftStats.exportPdf") }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <div>
      <v-data-table :headers="headers" :items="shiftsStats" :loading="loading" :pagination.sync="pagination">
        <template v-slot:items="props">
          <tr :class="{ 'deleted-captain': props.item.deleted_at }">
            <td class="text-xs-left">{{ `${props.item.position_by_active}` }}</td>
            <td class="text-xs-left">{{ `${props.item.username}` }}</td>
            <td class="text-xs-left">{{ `${props.item.first_name}` }}</td>
            <td class="text-xs-left">{{ `${props.item.last_name}` }}</td>
            <td class="text-xs-left">{{ `${props.item.active_count}` }}</td>
            <td class="text-xs-left">{{ `${props.item.mc}` }}</td>
            <td class="text-xs-left">{{ `${props.item.pext}` }}</td>
            <td class="text-xs-left">{{ `${props.item.ext}` }}</td>
            <td class="text-xs-left">{{ `${props.item.aero_nice}` }}</td>
            <td class="text-xs-left">{{ `${props.item.total_orders}` }}</td>
            <td class="text-xs-left">{{ `${props.item.red_orders_percentage}` }}</td>
            <td class="text-xs-left">{{ `${props.item.position_by_orders}` }}</td>
            <td class="text-xs-left">{{ `${props.item.avg_shifts_per_month}` }}</td>
            <td class="text-xs-left">{{ `${props.item.favorite_shift}` }}</td>
          </tr>
        </template>
      </v-data-table>

    </div>

  </div>
</template>

<style lang="scss"></style>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";

export default {
  name: "CaptainShiftStats",
  title() {
    return this.$t("drivers.captainShiftStats.title");
  },
  components: { ChooseDate, DatePickerMultiple },
  data() {
    return {
      from: null,
      to: null,
      driver_type: "All",
      selectedCaptain: null,
      searchCaptainParam: "",
      captains: [],
      selectedYear: null,
      selected_filter_by: "Day",
      selected_day: null,
      selected_month: null,
      selected_year: null,
      custom_month: null,
      custom_year: null,
      reservation: true,
      instant: true,
      loading: false,
      captainLoading: false,
      years: [],
      shiftsStats: [],
      pagination: {
        rowsPerPage: 25,
        sortBy: "position_by_active",
        descending: false
      },
      defaultSortOptions: {
        sortBy: ['active_count'],
        sortDesc: [true]
      }
    };
  },

  computed: {
    filterBy() {
      return [
        { text: this.$t("drivers.captainShiftStats.day"), value: "Day" },
        { text: this.$t("drivers.captainShiftStats.month"), value: "Month" },
        { text: this.$t("drivers.captainShiftStats.year"), value: "Year" },
        { text: this.$t("drivers.captainShiftStats.summerSeason"), value: "Summer Season" },
      ];
    },
    headers() {
      return [
        { text: this.$t('drivers.captainShiftStats.orderByShifts'), value: 'position_by_active', sortable: true },
        { text: this.$t('drivers.captainShiftStats.taxiNumber'), value: 'username', sortable: false },
        { text: this.$t('drivers.captainShiftStats.firstName'), value: 'first_name', sortable: false },
        { text: this.$t('drivers.captainShiftStats.lastName'), value: 'last_name', sortable: false },
        { text: this.$t('drivers.captainShiftStats.shifts'), value: 'active_count', sortable: false },
        { text: 'Monaco', value: 'mc', sortable: false },
        { text: 'PEXT', value: 'pext', sortable: false },
        { text: 'EXT', value: 'ext', sortable: false },
        { text: this.$t('drivers.captainShiftStats.niceAirports'), value: 'aero_nice', sortable: false },
        { text: this.$t('common.all'), value: 'total_orders', sortable: false },
        { text: this.$t('drivers.captainShiftStats.red_orders_percentage'), value: 'red_orders_percentage', sortable: false },
        { text: this.$t('drivers.captainShiftStats.orderByBookings'), value: 'position_by_orders', sortable: true },
        { text: this.$t('drivers.captainShiftStats.monthlyShiftsAvg'), value: 'avg_shifts_per_month', sortable: false },
        { text: this.$t('drivers.captainShiftStats.favoriteShift'), value: 'favorite_shift', sortable: false },
      ];
    },
  },

  watch: {
    searchCaptainParam() {
      this.getCaptains();
    },
    selected_month(val) {
      if (val) {
        this.from = moment(val).startOf("month").format("YYYY-MM-DD");
        this.to = moment(val).endOf("month").format("YYYY-MM-DD");
      }

      //this.getData(false);
    },
    selected_year(val) {
      if (val) {
        this.from = moment(val, "YYYY").startOf("year").format("YYYY-MM-DD");
        this.to = moment(val, "YYYY").endOf("year").format("YYYY-MM-DD");
      }

      //  this.getData(false);
    },
    selected_filter_by(val) {
      this.selected_year = null;
      this.selected_month = null;
      this.selected_day = moment().format("YYYY-MM-DD");
      this.from = this.selected_day;
      this.to = this.selected_day;

    }
    // selected_day(val) {
    //   // console.log(val);
    //   this.from = moment(val).format("YYYY-MM-DD");
    //   this.to = moment(val).format("YYYY-MM-DD");
    //  // this.getData(false);
    // },
    // from(val) {
    //   if (this.selected_filter_by == "Day" && val != null && this.to != null) {
    //     this.getData(false);
    //   }
    // },
    // to(val) {
    //   if (this.selected_filter_by == "Day" && val != null && this.from != null) {
    //     if (this.from == null) this.from = this.to;
    //     this.getData(false);
    //   }
    // },
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i);
    this.selected_day = moment().format("YYYY-MM-DD");
    this.from = this.selected_day;
    this.to = this.selected_day;
  },
  methods: {
    getCaptains() {
      if (!this.searchCaptainParam) {
        return;
      }
      this.captainLoading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchCaptainParam);
      params.append("trashed", 1);
      this.axios
        .get(`captain/search`, { params })
        .then((res) => {
          this.captains = res.data.data.map((captain) => ({
            text:
              `${captain.full_name || ""}` + " " + `${captain.username || ""}`,
            ...captain,
          }));
        })
        .finally(() => {
          this.captainLoading = false;
        });
    },
    getData(pdf) {

      this.loading = true;
      const params = new URLSearchParams();
      params.append("from", this.from);
      params.append("to", this.to);
      params.append("driver_type", this.driver_type);
      if (this.selectedCaptain)
        params.append("selected_captain", this.selectedCaptain);

      let summer_season = this.selected_filter_by == "Summer Season" ? 1 : 0;
      params.append("summer_season", summer_season);
      params.append("pdf", pdf ? 1 : 0);
      this.axios
        .get("captain-shifts-stats", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {

          if (pdf == false) {
            console.log(res)
            this.shiftsStats = res.data.data;
            console.log(this.shiftsStats)
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "ShiftsStatsReport.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },
    addPercentage(val1, val2) {
      let percentage = (val2 ? (val1 * 100 / val2) : 0).toFixed(2);
      return val1 + "(" + percentage + "%)"

    }
  }



};
</script>
<style lang="scss" scoped>
.deleted-captain td {
  color: red !important;
}

.options {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;

  // gap: 16px;
  .option {
    float: left;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;

    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: left;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }

    .percentage {
      width: 100%;
      padding: 0 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-left: 4px;
      }
    }
  }
}
</style>
